import { render, staticRenderFns } from "./christopher-yard.vue?vue&type=template&id=0f97ab30&"
import script from "./christopher-yard.vue?vue&type=script&lang=js&"
export * from "./christopher-yard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports